import { useState } from 'react';
import { testimonials } from '@/mocks/comics';

export default function TestimonialSection() {
  const [current, setCurrent] = useState(0);

  const goNext = () => setCurrent((prev) => (prev + 1) % testimonials.length);
  const goPrev = () => setCurrent((prev) => (prev - 1 + testimonials.length) % testimonials.length);

  const t = testimonials[current];

  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row gap-8 lg:gap-12">
          <div className="lg:w-2/5">
            <div className="relative aspect-[4/5] lg:aspect-[3/4] rounded-2xl overflow-hidden bg-accent-100">
              <img
                src={t.avatar}
                alt={t.name}
                className="w-full h-full object-cover"
              />
            </div>
          </div>

          <div className="lg:w-3/5 flex flex-col justify-center">
            <span className="text-xs font-semibold text-accent-600 tracking-wider uppercase mb-4">
              读者评价
            </span>
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 leading-tight mb-6">
              用户真实口碑
              <br />
              <span className="text-foreground-400 font-normal">听听漫画爱好者怎么说</span>
            </h2>

            <div className="flex items-center gap-1 mb-6">
              {Array.from({ length: 5 }).map((_, i) => (
                <div key={i} className="w-5 h-5 flex items-center justify-center">
                  <i className={`text-lg ${i < t.rating ? 'ri-star-fill text-accent-500' : 'ri-star-line text-foreground-300'}`}></i>
                </div>
              ))}
            </div>

            <blockquote className="text-base md:text-lg text-foreground-700 leading-relaxed mb-6 italic">
              &ldquo;{t.content}&rdquo;
            </blockquote>

            <div className="flex items-center gap-3">
              <div className="w-10 h-0.5 bg-foreground-300"></div>
              <span className="text-sm font-semibold text-foreground-900">{t.name}</span>
            </div>

            <div className="flex items-center gap-3 mt-8">
              <button
                onClick={goPrev}
                className="w-10 h-10 flex items-center justify-center rounded-full border border-foreground-300 hover:bg-background-200 transition-colors cursor-pointer"
              >
                <i className="ri-arrow-left-line text-foreground-700"></i>
              </button>
              <button
                onClick={goNext}
                className="w-10 h-10 flex items-center justify-center rounded-full bg-foreground-900 hover:bg-foreground-800 text-background-50 transition-colors cursor-pointer"
              >
                <i className="ri-arrow-right-line"></i>
              </button>
              <span className="text-xs text-foreground-400 ml-2">
                {current + 1} / {testimonials.length}
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}